import {
  CreateSubtask,
  CreateTaskRequest,
  Task,
  TaskStudySkill,
  TaskType,
  TaskForm,
  SubtaskForm,
  UpdateSubtask,
  UpdateTaskRequest,
} from '@lyceo/shared/plan/util-models';
import { format, parseISO } from 'date-fns';

export function formatCreateRequest(
  form: TaskForm,
  type: TaskType,
): CreateTaskRequest {
  return {
    type: type,
    course: `/api/courses/${form.course}`,
    title: form.title,
    scheduledAt: format(parseISO(form.scheduledAt), 'yyyy-MM-dd'),
    subTasks: form.subtasks.map((subtask) => formatCreateSubtask(subtask)),
  };
}

export function formatUpdateRequest(
  form: TaskForm,
  task: Task,
): UpdateTaskRequest {
  return {
    ...formatCreateRequest(form, task.type),
    id: task.id,
    subTasks: form.subtasks.map((subtask) => formatUpdateSubtask(subtask)),
  };
}

export function formatUpdateSubtask(subtask: SubtaskForm): UpdateSubtask {
  const updateSubtask: UpdateSubtask = formatCreateSubtask(subtask);

  if (subtask.id) {
    updateSubtask.id = subtask.id;
  }

  return updateSubtask;
}

export function formatCreateSubtask(subtask: SubtaskForm): CreateSubtask {
  const request: CreateSubtask = {
    title: subtask.title,
    scheduledAt: format(parseISO(subtask.scheduledAt), 'yyyy-MM-dd'),
    type: subtask.type as TaskType,
  };

  if (subtask.studySkill) {
    request.studySkill = subtask.studySkill as TaskStudySkill;
  }

  if (subtask.estimatedDuration) {
    request.estimatedDuration = subtask.estimatedDuration;
  }

  return request;
}
